<template>
  <div>
    <filters
      :source="[]"
      @highwaySelected="updateFilterData('highway', $event)"
      @dateFromSelected="updateFilterData('dateFrom', $event)"
      @dateToSelected="updateFilterData('dateTo', $event)"
    />
    <catalog-table-async
      ref="quotationsTable"
      title="Cotizaciones"
      searchPlaceholder="Buscar por folio"
      v-model="currentPage"
      :tableHeaders="tableHeaders"
      :tableData="quotations"
      :paginationTotalItems="totalItems"
      :actions="tableActions"
      :loading="loading"
      @updatedSearchQuery="updateSearchQuery"
    />

    <quotation-modal
      :quotation="currentQuotation"
      @saved="quotationSaved"
      v-if="showModal"
      @close="showModal = false"
    />
  </div>
</template>

<script>
import Filters from "./Filters";
import purchaseService from "@/services/purchase";
import { CatalogTableAsync, Modal } from "@/components";
import QuotationModal from "./Edit";
import { debounce } from "lodash";

export default {
  name: "Quotations",

  components: {
    CatalogTableAsync,
    QuotationModal,
    Filters,
    Modal,
  },

  created() {
    this.fetchQuotations(0, 5);
  },

  methods: {
    fetchQuotations(page, size) {
      this.loading = true;
      const search = this.searchQuery;
      const filterParams = this.filterParams;
      return purchaseService
        .fetchQuotations({ page, size, search, ...filterParams })
        .then((quotationsWithPagination) => {
          this.loading = false;
          let data = quotationsWithPagination[0];
          this.quotations = data.quotations;
          this.size = data.size;
          this.page = data.page;
          this.totalItems = data.totalItems;
        })
        .catch(() => (this.loading = false));
    },
    editQuotation(quotation) {
      this.currentQuotation = quotation;
      this.showModal = true;
    },
    quotationSaved(quotation) {
      this.showModal = false;
      const quotations = this.quotations;
      let index = quotations.filter((q) => q.id == quotation.id)[0];
      index = quotations.indexOf(index);
      this.quotations.splice(index, 1);
      this.$successMessage({
        title: `Cotización ${quotation.folio} actualizada`,
      });
    },
    updateSearchQuery(text) {
      this.searchQuery = text;
    },
    updateFilterData(field, value) {
      this.filterParams[field] = value;
    },
  },
  data() {
    const tableHeaders = {
      folio: "Folio",
      highwayName: "Autopista",
      campName: "Campamento",
      numSinister: "No. de Siniestro",
    };
    return {
      loading: null,
      showModal: false,
      currentQuotation: null,
      quotations: [],
      currentPage: {
        size: 5,
        page: 0,
      },
      filterParams: {
        highway: null,
        dateTo: null,
        dateFrom: null,
      },
      searchQuery: "",
      page: Number,
      size: Number,
      totalItems: null,
      tableHeaders,
      propsToSearch: Object.keys(tableHeaders),
      tableActions: [
        {
          icon: "edit",
          exe: this.editQuotation,
        },
      ],
    };
  },
  watch: {
    currentPage: function (val, oldVal) {
      const { page, size } = val;
      if (val != null) {
        this.fetchQuotations(page - 1, size);
      }
    },
    filterParams: {
      deep: true,
      handler: function () {
        const { page, size } = this.currentPage;
        this.currentPage = { page: 0, size };
        this.fetchQuotations(0, size);
      },
    },
    searchQuery: debounce(function (val) {
      const { size } = this.currentPage;
      const page = 1;
      if (val != null) {
        this.currentPage.page = page;
        this.fetchQuotations(page - 1, size).then(() => {
          this.$refs.quotationsTable.focusSearch();
        });
      }
    }, 500),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Purchases/Quotations/index.vue